import React from 'react'
import { ModernBlockProps } from '../modernBlocks/modernBlocks.state';
import { List } from 'immutable';
import { slugify } from '../../../../Shared/Frontend/utils/slugify';
import { htmlDecode } from '../utils/html';

export const TableOfContents = {
  Wrapper: (props: { blocks: List<ModernBlockProps> }): JSX.Element => (
    props.blocks.toArray().some(block => block.props.title?.trim()) ?
      <div className="block block--text block--highlight highlight--lightred">
        <nav className="block__inner ls-container ls-gutter ls-spacing--s">
          <div className="block__layout text--styled">
            <TableOfContents.Nav blocks={props.blocks} />
          </div>
        </nav>
      </div> : <></>
  ),
  Nav: (props: { blocks: List<ModernBlockProps> }): JSX.Element => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
      event.preventDefault();
      const targetElement = document.getElementById(id);
      if (targetElement)
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
      <ol className='block__layout-inner ls-gutter ls-spacing'>
        {props.blocks.toArray().map((block) => block.props.title && block.kind !== "donationFormBlock" && !block.props.excludeFromPageMenu
          ? <li key={slugify(htmlDecode(block.props.title))}>
              <a
                href={`#${slugify(htmlDecode(block.props.title))}`}
                onClick={(e) => handleClick(e, slugify(htmlDecode(block.props.title)))}
              >
                {block.props.title}
              </a>
            </li>
          : null
        )}
      </ol>
    )
  }
}

